import { getUrl } from '@buffer-mono/shared-utils/bibe'

import { navigateTo } from '~publish/helpers/navigation'

import { trackImpersonateStopRedirect } from './authObservability'
import {
  CALLBACKS_PRODUCTION_URL,
  OIDC_IMPERSONATE_STOP_PATH,
} from './constants'

/**
 * Ends impersonation when a refresh reports an impersonated session. The
 * endpoint revokes the impersonation token and re-authorizes the advocate back
 * onto their own account, so no `return_url` is passed — it owns the post-stop
 * destination. `getUrl` env-stamps the callbacks host for dev/local/bibe.
 */
export function redirectToImpersonateStop(): void {
  trackImpersonateStopRedirect()

  navigateTo(getUrl(`${CALLBACKS_PRODUCTION_URL}${OIDC_IMPERSONATE_STOP_PATH}`))
}
